import { Cross1Icon } from '@radix-ui/react-icons';
import { DropdownMenu, Flex, IconButton, Text } from '@radix-ui/themes';
import { TruncatedTooltip } from '../../../common/components/TruncatedTooltip';

interface SelectionDropdownItemProps {
    rowId: string;
    label: string;
    onToggleRowSelection: (rowId: string) => void;
}

export const SelectionDropdownItem = ({
    rowId,
    label,
    onToggleRowSelection,
}: SelectionDropdownItemProps) => {
    const handleClearClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        onToggleRowSelection(rowId);
    };

    return (
        <DropdownMenu.CheckboxItem
            key={rowId}
            checked={true}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
        >
            <Flex
                gap={'3'}
                align={'center'}
                justify={'between'}
                width={'250px'}
            >
                <TruncatedTooltip>
                    <Text ml={'2'}>{label}</Text>{' '}
                </TruncatedTooltip>
                <IconButton
                    size='1'
                    variant='ghost'
                    onClick={handleClearClick}
                    aria-label={`Unselect ${label}`}
                >
                    <Cross1Icon />
                </IconButton>
            </Flex>
        </DropdownMenu.CheckboxItem>
    );
};
